import { useState } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from '../components/Lightbox';

export default function UdlejningSlushice() {
  const [activePhotoIdx, setActivePhotoIdx] = useState(null);
  const images = [
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/imgi-73-498030673-122133800990785719-4494842369837955426-n.jpg',
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/slushice.webp',
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image6_1.jpeg',
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image11_1.jpeg',
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image9_1.jpeg',
    'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image10_1.jpeg'
  ];

  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      <div className="border-b border-stone-200 bg-white/90 py-4 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <Link to="/" className="transition-colors hover:text-brand-orange">Forside</Link>
            <i className="fa-solid fa-chevron-right text-xs text-stone-300" />
            <Link to="/udlejning" className="transition-colors hover:text-brand-orange">Udlejning</Link>
            <i className="fa-solid fa-chevron-right text-xs text-stone-300" />
            <span className="text-slate-700">Slushice maskine</span>
          </div>
        </div>
      </div>

      <section className="flex-grow py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-start">
            <div className="rounded-[1.75rem] border border-stone-200 bg-white p-8 shadow-[0_12px_30px_rgba(148,163,184,0.08)]">
              <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Festudlejning</span>
              <h1 className="mt-2 mb-6 text-3xl font-semibold text-slate-800">Slushice maskine</h1>

              <div className="prose prose-slate mb-8 max-w-none text-slate-500">
                <p className="text-base leading-relaxed mb-4">
                  Gør din næste fest til en sikker succes med en professionel slushice maskine! Vores maskiner har 2 kamre, så du kan tilbyde flere forskellige lækre smagsvarianter på samme tid. Perfekt til børnefødselsdage, konfirmationer, havefester, eller som en sjov detalje til voksenfesten med alkohol tilføjet.
                </p>
                <p className="text-base leading-relaxed">
                  Maskinen er utrolig nem at betjene. Vi leverer den ren og klar til brug, og vi sørger også for rengøringen bagefter, så du slipper for besværet.
                </p>
              </div>

              <div className="mb-8 rounded-2xl bg-stone-50 p-6 border border-stone-100">
                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-3">Priser & Vilkår</h3>
                <ul className="space-y-2.5 text-sm text-slate-600">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-circle text-[6px] text-brand-orange" />
                    <span className="font-semibold text-slate-800">Fra 450 kr. pr. døgn</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-circle text-[6px] text-brand-orange" />
                    <span>Hele weekenden for kun 600 kr.</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-circle text-[6px] text-brand-orange" />
                    <span>Et døgn er fra kl. 11:00 til 11:00</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-circle text-[6px] text-brand-orange" />
                    <span>En weekend er fra fredag kl. 11:00 til søndag kl. 11:00</span>
                  </li>
                </ul>
              </div>

              <div className="border-t border-stone-200 pt-8">
                <h3 className="mb-4 text-lg font-semibold text-slate-800">Kontakt os</h3>
                <div className="flex flex-col gap-4">
                  <a
                    href="tel:22426011"
                    className="inline-flex items-center justify-center gap-3 rounded-full bg-brand-orange px-6 py-3.5 text-base font-bold text-white transition-colors hover:bg-brand-orange-hover"
                  >
                    <i className="fa-solid fa-phone" />
                    <span>22 42 60 11</span>
                  </a>
                  <Link
                    to="/kontakt"
                    className="inline-flex items-center justify-center gap-3 rounded-full border border-stone-200 bg-white px-6 py-3.5 text-base font-bold text-slate-700 transition-colors hover:border-brand-orange hover:text-brand-orange"
                  >
                    <i className="fa-solid fa-envelope" />
                    <span>Forespørg leje</span>
                  </Link>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {images.map((src, idx) => (
                <div
                  key={idx}
                  className="h-80 overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white cursor-zoom-in"
                  onClick={() => setActivePhotoIdx(idx)}
                >
                  <img
                    src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/${src}`}
                    alt={`Slushice maskine ${idx + 1}`}
                    className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Lightbox
        images={images}
        currentIndex={activePhotoIdx}
        onClose={() => setActivePhotoIdx(null)}
        onPrev={() => setActivePhotoIdx((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
        onNext={() => setActivePhotoIdx((prev) => (prev === images.length - 1 ? 0 : prev + 1))}
      />
    </div>
  );
}
